import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import { socket } from '../utils/utils'
import { useDispatch, useSelector } from 'react-redux'
import { updateCustomer, updateSellers } from '../store/Reducers/chatReducer'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import cookies from 'js-cookie'

const languages = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    country_code: 'en',
    image: '../../../images/language.png',
  },
  {
    code: 'kr',
    name: 'کوردی',
    dir: 'rtl',
    country_code: 'kr',
    image: '../../../images/kur.png',
  },
  {
    code: 'ar',
    name: 'عربي',
    dir: 'rtl',
    country_code: 'ar',
    image: '../../../images/kur.png',
  },
]

const MainLayout = () => {
  const currentLanguageCode = cookies.get('i18next') || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { userInfo } = useSelector((state) => state.auth)

  // useEffect(() => {
  //   if (userInfo && userInfo.role === 'seller') {
  //     socket.emit('add_seller', userInfo._id, userInfo)
  //   } else {
  //     socket.emit('add_admin', userInfo)
  //   }
  // }, [userInfo])

  useEffect(() => {
    const adminRoles = ['admin', 'stockAdmin', 'orderAdmin', 'poster']
    if (userInfo && adminRoles.includes(userInfo.role)) {
      const emitAdminGroup = () => {
        socket.emit('add_admin_group', userInfo._id, userInfo)
      }
      emitAdminGroup()
      socket.on('connect', emitAdminGroup)
      
      return () => {
        socket.off('connect', emitAdminGroup)
      }
    }
  }, [userInfo])

  useEffect(() => {
    socket.on('activeCustomer', (customers) => {
      dispatch(updateCustomer(customers))
    })
    socket.on('activeSeller', (sellers) => {
      dispatch(updateSellers(sellers))
    })
  })

  const [showSidebar, setShowSidebar] = useState(false)

  return (
    <div className="bg-[#F9FBFE] w-full min-h-screen">
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div
        className={` ${
          currentLanguage.dir === 'ltr'
            ? 'ml-0 lg:ml-[260px]'
            : 'mr-0 lg:mr-[260px]'
        } ${currentLanguage.dir} pt-[95px] transition-all`}
      >
        <Outlet />
      </div>
    </div>
  )
}

export default MainLayout
